<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon name="arrow-back-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-start"> {{ title }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-horizontal">
  <div class="center">
    <ion-grid fixed>
      <ion-row>
        <ion-col
          size="7"
          style="display: flex; justify-content: center; align-items: center"
        >
          <ng-container *ngIf="info.video_url; else noInfo">
            <!-- <video
            *ngIf="!youtube; else ytVid"
            #video
            class="fullscreen-bg__video"
            id="video"
            controls
            (ended)="dismiss('ended')"
            autoplay="true"
            [src]="videoUrl"
            width="90%"
          ></video> -->

            <iframe
              width="100%"
              height="250px"
              [src]="info.video_url | safe"
              allowfullscreen
              style="border-radius: 25px"
            >
            </iframe>
          </ng-container>

          <ng-template #noInfo>
            <ion-text class="ion-text-center">
              <p>Este vídeo no se encuentra disponible</p>
              <ion-icon
                name="warning-outline"
                style="font-size: 20px"
              ></ion-icon>
            </ion-text>
          </ng-template>
        </ion-col>

        <ion-col
          size="5"
          style="display: flex; justify-content: center; align-items: center"
        >
          <ion-row>
            <ion-col size="12">
              <div class="box">
                <h1>{{ info.numero_semana }}</h1>
                <p style="margin-top: -8px">Semanas</p>
              </div>
            </ion-col>
            <ion-col size="12">
              <div class="box">
                <h1>{{ info.numero_entrenamiento }}</h1>
                <p style="margin-top: -8px">Entrenamientos</p>
              </div>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="12"
          style="
            display: flex;
            justify-content: center;
            align-items: start;
            flex-direction: column;
          "
        >
          <h3 style="font-weight: bold">¿Que significa {{ title }}?</h3>
          <ion-chip outline color="tertiary">
            <ion-label>{{ info.numero_semana }} semanas</ion-label>
          </ion-chip>
          <div
            style="font-size: 13px"
            [innerHtml]="info.informacion_detallada"
            *ngIf="info.informacion_detallada; else noInfo"
          ></div>
          <ng-template #noInfo>
            <ion-text class="ion-text-center">
              <p>No existe Información sobre este {{ from }}</p>
              <ion-icon
                name="warning-outline"
                style="font-size: 20px"
              ></ion-icon>
            </ion-text>
          </ng-template>
        </ion-col>
      </ion-row>
      <br />
      <ion-row *ngIf="info.faqs">
        <ion-col
          size="12"
          style="
            display: flex;
            justify-content: center;
            align-items: start;
            flex-direction: column;
            border-top: 1px solid lightgray;
          "
        >
          <h3 style="font-weight: bold">Dudas frecuentes</h3>
          <ion-list class="items" style="width: 100%">
            <ng-container *ngFor="let item of info.faqs">
              <ion-item
                color="tertiary"
                style="border-radius: 5px; margin-bottom: 5px"
                (click)="expandItem(item)"
              >
                <ion-icon
                  slot="end"
                  [name]="item.expanded ? 'remove' : 'add'"
                ></ion-icon>
                <ion-label style="white-space: pre-wrap; font-size: 13px">
                  {{ item.pregunta }}
                </ion-label>
              </ion-item>
              <div
                class="expand-wrapper"
                *ngIf="item.expanded"
                [innerHtml]="item.respuesta | safeHtml"
              ></div>
            </ng-container>
          </ion-list>
        </ion-col>
      </ion-row>
      <!-- <ion-row>
        <ion-col size="12">
          <ion-button
            (click)="dismiss()"
            expand="block"
            color="primary"
            shape="round"
          >
            Volver a entrenamientos
          </ion-button>
        </ion-col>
      </ion-row> -->
      <ng-template #spinner>
        <div class="spinner" style="height: 100%">
          <ion-row>
            <ion-col
              size="12"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner></ion-spinner>
            </ion-col>
          </ion-row>
        </div>
      </ng-template>
    </ion-grid>
  </div>
</ion-content>
